export default __webpack_public_path__ + "static/media/Quality.4ae88600.jpg";